export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13535.8c78e1c9.jpg";